var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _rect2, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageErrorFatal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 329,
    viewBox: "0 0 590 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.275,
    cy: 75.6183,
    r: 48.6183,
    fill: "#DFE7EE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.6182,
    cy: 109.043,
    r: 33.4251,
    fill: "#DFE7EE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.241,
    cy: 118.16,
    r: 24.3092,
    fill: "#DFE7EE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.018,
    cy: 109.803,
    r: 29.6268,
    fill: "#DFE7EE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.418,
    cy: 102.966,
    r: 42.541,
    fill: "#DFE7EE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.959,
    cy: 118.159,
    r: 28.8671,
    fill: "#DFE7EE"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.23,
    cy: 145.507,
    r: 21.2705,
    fill: "#DFE7EE"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2705,
    cy: 145.507,
    r: 21.2705,
    fill: "#DFE7EE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.2318,
    y: 115.121,
    width: 278.036,
    height: 51.657,
    fill: "#DFE7EE"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.128,
    cy: 153.936,
    r: 71.9362,
    fill: "#DFE7EE"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.585,
    cy: 172.287,
    r: 35.9681,
    fill: "#DFE7EE"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.138,
    cy: 181.096,
    r: 35.9681,
    fill: "#DFE7EE"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.298,
    cy: 189.17,
    r: 14.6809,
    fill: "#DFE7EE"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.085,
    cy: 212.66,
    r: 19.0851,
    fill: "#DFE7EE"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.915,
    cy: 212.66,
    r: 19.0851,
    fill: "#DFE7EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 330.149,
    y: 196.511,
    width: 240.766,
    height: 35.234,
    fill: "#DFE7EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254.247 112.084C250.247 118.417 241.647 134.284 239.247 147.084C236.847 159.884 235.913 179.75 235.747 188.084M254.247 112.084L266.747 123.084C264.247 136.584 258.247 165.884 254.247 175.084C250.247 184.284 240.247 187.584 235.747 188.084M254.247 112.084C239.747 104.417 206.147 94.4836 187.747 116.084C186.637 117.387 185.636 118.693 184.738 120M235.747 188.084C232.247 188.81 202.747 178.584 195.747 175.084C191.843 173.132 182.653 163.405 179.275 150.5M184.738 120C180.825 118.556 172.1 117.151 168.5 123.084M184.738 120C177.403 130.673 176.888 141.38 179.275 150.5M168.5 123.084C165.5 120 129 93.9999 127.5 67.9999C126 41.9999 130 32.9999 138 25.4999C146 17.9999 157.5 13.9999 165.5 14.9999C173.5 15.9999 176 15 176.5 12C177 8.99999 175 3.49999 168.5 3.49999C162 3.49999 148.5 7.05719e-05 138 7.49999C127.5 14.9999 121.5 23 117.5 35C113.5 47 114 70 117.5 79C121 88 127 103.5 137 114.5C145 123.3 158.295 133.167 163.943 137M168.5 123.084C165.519 127.997 163.854 132.91 163.943 137M179.275 150.5C173.811 149.5 168.5 147.084 165.5 142.5C164.488 140.953 163.988 139.083 163.943 137",
    stroke: "#0053BF",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.5 148L281.5 141.5C273.833 139.5 258.2 135.5 257 135.5C255.5 135.5 253 135.5 252 139C251.2 141.8 253.667 144.167 255 145L301 158C302.5 158.5 306 158.7 308 155.5C310 152.3 307.167 149.167 305.5 148Z",
    stroke: "#0053BF",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M297.656 174.5L273.656 168C265.99 166 250.356 162 249.156 162C247.656 162 245.156 162 244.156 165.5C243.356 168.3 245.823 170.667 247.156 171.5L293.156 184.5C294.656 185 298.156 185.2 300.156 182C302.156 178.8 299.323 175.667 297.656 174.5Z",
    stroke: "#0053BF",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205 120.5C206.833 118.833 212.2 115.6 219 116C225.8 116.4 232.833 119.167 235.5 120.5",
    stroke: "#0053BF",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 220L327.5 209C328.167 204.167 330 192 332 182C334 172 339.833 156.167 342.5 149.5L358.5 141M338.5 220C341.333 215 347.8 202.7 351 193.5C355 182 358.5 168.5 358.5 159C358.5 151.4 358.5 143.833 358.5 141M338.5 220C339.833 221 343.7 223.4 348.5 225C354.5 227 358.5 228.5 372 229.5C385.5 230.5 395.5 224.5 404.5 217.5C406.255 216.135 407.744 214.466 409 212.596M358.5 141C365.5 141.333 382.7 144.6 395.5 155C411.5 168 414.5 177.5 415 186.5C415.402 193.745 414.185 204.878 409 212.596M409 212.596C411.333 213.199 416.5 214.223 418.5 213.5C420.115 212.916 422.564 209.749 424.5 206.502M415 183C419.5 182.5 424.5 184.5 427 189C428.364 191.455 428.686 193.761 428.454 196M424.5 206.502C425.562 204.721 426.469 202.916 427 201.5C427.682 199.682 428.26 197.865 428.454 196M424.5 206.502C438.333 209.001 465.7 222.9 464.5 258.5C463.3 294.1 435.333 310.333 421.5 314C419.833 316.167 416.9 321.2 418.5 324C420.1 326.8 424.833 326.833 427 326.5C442.333 322.499 474.2 303.699 479 260.5C482.945 225 447.302 199.501 428.454 196M372 217.5C375.833 218.135 384.4 218.723 388 216C391.6 213.277 398.5 207.199 401.5 204.5",
    stroke: "#0053BF",
    strokeWidth: 4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 339,
    cy: 193.976,
    rx: 2.67322,
    ry: 7.61964,
    transform: "rotate(10.3611 339 193.976)",
    fill: "#0053BF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 346,
    cy: 166.976,
    rx: 2.67322,
    ry: 7.61964,
    transform: "rotate(10.3611 346 166.976)",
    fill: "#0053BF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157 179.5C157 180 156.5 183 155.5 183C154.5 183.5 153 184 152.5 184C152 184 151.5 184 151.5 184.5C151.5 184.9 152.167 185.333 152.5 185.5C153.167 185.667 154.7 186 155.5 186C156.3 186 156.5 188.333 156.5 189.5C156.5 189.667 156.6 190 157 190C157.4 190 157.833 189.667 158 189.5C158 188.667 158.2 186.8 159 186C160 185 163 185.5 163 185C163 184.6 162.333 184.167 162 184C161.333 183.833 159.8 183.4 159 183C158 182.5 158 178 157.5 178C157 178 157 179 157 179.5Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.304 159.125C112.304 159.5 111.913 161.75 111.13 161.75C110.348 162.125 109.174 162.5 108.783 162.5C108.391 162.5 108 162.5 108 162.875C108 163.175 108.522 163.5 108.783 163.625C109.304 163.75 110.504 164 111.13 164C111.757 164 111.913 165.75 111.913 166.625C111.913 166.75 111.991 167 112.304 167C112.617 167 112.957 166.75 113.087 166.625C113.087 166 113.243 164.6 113.87 164C114.652 163.25 117 163.625 117 163.25C117 162.95 116.478 162.625 116.217 162.5C115.696 162.375 114.496 162.05 113.87 161.75C113.087 161.375 113.087 158 112.696 158C112.304 158 112.304 158.75 112.304 159.125Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228.391 50.625C228.391 50.8333 228.174 52.0833 227.739 52.0833C227.304 52.2917 226.652 52.5 226.435 52.5C226.217 52.5 226 52.5 226 52.7083C226 52.875 226.29 53.0556 226.435 53.125C226.725 53.1944 227.391 53.3333 227.739 53.3333C228.087 53.3333 228.174 54.3056 228.174 54.7917C228.174 54.8611 228.217 55 228.391 55C228.565 55 228.754 54.8611 228.826 54.7917C228.826 54.4444 228.913 53.6667 229.261 53.3333C229.696 52.9167 231 53.125 231 52.9167C231 52.75 230.71 52.5694 230.565 52.5C230.275 52.4306 229.609 52.25 229.261 52.0833C228.826 51.875 228.826 50 228.609 50C228.391 50 228.391 50.4167 228.391 50.625Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.174 83.875C188.174 84.5 187.522 88.25 186.217 88.25C184.913 88.875 182.957 89.5 182.304 89.5C181.652 89.5 181 89.5 181 90.125C181 90.625 181.87 91.1667 182.304 91.375C183.174 91.5833 185.174 92 186.217 92C187.261 92 187.522 94.9167 187.522 96.375C187.522 96.5833 187.652 97 188.174 97C188.696 97 189.261 96.5833 189.478 96.375C189.478 95.3333 189.739 93 190.783 92C192.087 90.75 196 91.375 196 90.75C196 90.25 195.13 89.7083 194.696 89.5C193.826 89.2917 191.826 88.75 190.783 88.25C189.478 87.625 189.478 82 188.826 82C188.174 82 188.174 83.25 188.174 83.875Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M375.783 117.25C375.783 117.667 375.348 120.167 374.478 120.167C373.609 120.583 372.304 121 371.87 121C371.435 121 371 121 371 121.417C371 121.75 371.58 122.111 371.87 122.25C372.449 122.389 373.783 122.667 374.478 122.667C375.174 122.667 375.348 124.611 375.348 125.583C375.348 125.722 375.435 126 375.783 126C376.13 126 376.507 125.722 376.652 125.583C376.652 124.889 376.826 123.333 377.522 122.667C378.391 121.833 381 122.25 381 121.833C381 121.5 380.42 121.139 380.13 121C379.551 120.861 378.217 120.5 377.522 120.167C376.652 119.75 376.652 116 376.217 116C375.783 116 375.783 116.833 375.783 117.25Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M313.174 270.875C313.174 271.5 312.522 275.25 311.217 275.25C309.913 275.875 307.957 276.5 307.304 276.5C306.652 276.5 306 276.5 306 277.125C306 277.625 306.87 278.167 307.304 278.375C308.174 278.583 310.174 279 311.217 279C312.261 279 312.522 281.917 312.522 283.375C312.522 283.583 312.652 284 313.174 284C313.696 284 314.261 283.583 314.478 283.375C314.478 282.333 314.739 280 315.783 279C317.087 277.75 321 278.375 321 277.75C321 277.25 320.13 276.708 319.696 276.5C318.826 276.292 316.826 275.75 315.783 275.25C314.478 274.625 314.478 269 313.826 269C313.174 269 313.174 270.25 313.174 270.875Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M443.913 253.5C443.913 253.667 443.739 254.667 443.391 254.667C443.043 254.833 442.522 255 442.348 255C442.174 255 442 255 442 255.167C442 255.3 442.232 255.444 442.348 255.5C442.58 255.556 443.113 255.667 443.391 255.667C443.67 255.667 443.739 256.444 443.739 256.833C443.739 256.889 443.774 257 443.913 257C444.052 257 444.203 256.889 444.261 256.833C444.261 256.556 444.33 255.933 444.609 255.667C444.957 255.333 446 255.5 446 255.333C446 255.2 445.768 255.056 445.652 255C445.42 254.944 444.887 254.8 444.609 254.667C444.261 254.5 444.261 253 444.087 253C443.913 253 443.913 253.333 443.913 253.5Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M425.826 154C425.826 154.333 425.478 156.333 424.783 156.333C424.087 156.667 423.043 157 422.696 157C422.348 157 422 157 422 157.333C422 157.6 422.464 157.889 422.696 158C423.159 158.111 424.226 158.333 424.783 158.333C425.339 158.333 425.478 159.889 425.478 160.667C425.478 160.778 425.548 161 425.826 161C426.104 161 426.406 160.778 426.522 160.667C426.522 160.111 426.661 158.867 427.217 158.333C427.913 157.667 430 158 430 157.667C430 157.4 429.536 157.111 429.304 157C428.841 156.889 427.774 156.6 427.217 156.333C426.522 156 426.522 153 426.174 153C425.826 153 425.826 153.667 425.826 154Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageErrorFatal);
export default __webpack_public_path__ + "static/media/Image_Error_Fatal.8e74d5db8fc3dc875d602eb624b9b33e.svg";
export { ForwardRef as ReactComponent };